import React, { useContext } from 'react'
import { Context } from './Context'
import Modal from 'components/common/Modal'
import SanityBlock from 'components/common/SanityBlock'
import * as css from './EmployeeDetails.module.css'
import clsx from 'clsx'

import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Keyboard } from 'swiper'
import 'swiper/css'
import 'swiper/css/navigation'

const EmployeeDetails = ({ name, title, education, licenses, certs, _rawRole, experiences }) => {
  const { set$active } = useContext(Context)

  return (
    <Modal className="max-w-screen-sm mx-auto rounded-2xl overflow-hidden" onClose={() => set$active(false)}>
      <Swiper
        className={css.swiper}
        modules={[Navigation, Keyboard]}
        navigation
        keyboard
      >
        <SwiperSlide className={css.slide}>
          <h2 className="h2">{name}</h2>
          <p className="technical">{title}</p>

          <dl>
            <Dataset title="Education" data={education} />
            <Dataset title="Licenses" data={licenses} />
            <Dataset title="Training/Certifications" data={certs} />
          </dl>
        </SwiperSlide>

        {!!_rawRole && (
          <SwiperSlide className={css.slide}>
            <h2 className="technical font-bold mb-2">Role at FASTECH</h2>
            <SanityBlock body={_rawRole} />
          </SwiperSlide>
        )}

        {experiences?.map(({ _rawContent }, key) => (
          <SwiperSlide className={clsx(css.slide, css.experience)} key={key}>
            <p className="technical font-bold">Prior to FASTECH</p>
            <SanityBlock body={_rawContent} components={components} />
          </SwiperSlide>
        ))}
      </Swiper>
    </Modal>
  )
}

export default EmployeeDetails

const Dataset = ({ title, data }) => !!data?.length && <>
  <dt className="technical font-bold mt-4">{title}</dt>
  <dd>
    <ul className="styled-list">
      {data?.map((text, key) => (
        <li key={key}>{text}</li>
      ))}
    </ul>
  </dd>
</>

const components = {
  list: ({ children }) => <ul className="!p-0 styled-list">{children}</ul>,
}
